const ITEMS = [
  "Veille du marché",
  "Contenus & pubs",
  "Réponse 24/7",
  "Agenda rempli",
  "Vous validez, elle exécute",
  "Sur devis, sans surprise",
];

const Track = ({ hidden = false }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center gap-10 pr-10">
    {ITEMS.map((t) => (
      <span
        key={t}
        className="flex items-center gap-10 font-mono text-sm uppercase tracking-[0.28em] text-mist whitespace-nowrap"
      >
        {t}
        <svg width="10" height="10" viewBox="0 0 10 10" className="text-viol" aria-hidden="true">
          <rect x="1.5" y="1.5" width="7" height="7" rx="1.5" transform="rotate(45 5 5)" fill="currentColor" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative border-y border-ink-line bg-ink-soft/70 py-5 overflow-hidden" data-testid="editorial-marquee">
    <div className="flex w-max animate-marquee">
      <Track />
      <Track hidden />
    </div>
  </div>
);

export default Marquee;
